import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { contact } from '../../data/site';
export function ContactSection() {
  return <section aria-labelledby="contact-title" className="bg-paper-deep" data-id="element-6" data-mp="1v4v2zxhtycgz">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-20 lg:grid-cols-12 lg:items-center lg:px-10 lg:py-24" data-id="element-7" data-mp="1v4lfcgk9cheg">
        <div className="lg:col-span-7" data-id="element-8" data-mp="201ljun1glc3g">
          <h2 id="contact-title" className="font-display text-4xl font-medium leading-tight md:text-5xl" data-id="element-9" data-mp="1m3x762hjpb9h">
            Commençons par un échange.
          </h2>
          <p className="mt-5 max-w-lg leading-relaxed text-ink-soft" data-id="element-10" data-mp="1r0x7rxvmllt7">
            Cours, atelier ou consultation : écrivez quelques mots sur votre situation, Elisabete vous
            répond sous 48 heures.
          </p>
        </div>
        <div className="flex flex-col gap-4 lg:col-span-4 lg:col-start-9 lg:items-end" data-id="element-11" data-mp="36js8ehybneai">
          <Link to="/contact" className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-wood px-7 py-3.5 text-sm font-medium text-paper transition-colors duration-150 hover:bg-wood-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-wood focus-visible:ring-offset-4 focus-visible:ring-offset-paper-deep" data-id="element-12" data-mp="3bjmw6cmsvnrc">
            Prendre contact
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-13" data-mp="2c9z59y8xs0im" />
          </Link>
          <a href={`mailto:${contact.email}`} className="text-sm text-ink-soft transition-colors duration-150 hover:text-wood" data-id="element-14" data-mp="1ok4s1fkpg9xu">
            ou {contact.email}
          </a>
        </div>
      </div>
    </section>;
}